import AddonsCallToAction from '../../../page-fragments/product-details/AddonsCallToAction';
import BranchContactPhone from '../../../components/equipment-branch-contact/BranchContact';
import ProductCallToAction from '../../../page-fragments/product-details/ProductCallToAction';
import renderer from '../../renderer';
import { useEffect } from 'react';
import {
  GenericRendererComponent,
  RendererComponentType,
  RendererSelectorType,
} from '../../../types/renderer';

const componentsRegister: GenericRendererComponent[] = [
  {
    componentType: RendererComponentType.GENERIC,
    selectorType: RendererSelectorType.ID,
    selector: 'esr-pd-price-widget',
    component: ({ equipment_id }) => {
      return equipment_id && <ProductCallToAction equipmentId={equipment_id} />;
    },
  },
  {
    componentType: RendererComponentType.GENERIC,
    selectorType: RendererSelectorType.CLASS,
    selector: 'esr-pd-addon-cta',
    component: ({ equipment_id }) => {
      return equipment_id && <AddonsCallToAction equipmentId={equipment_id} />;
    },
  },
  {
    componentType: RendererComponentType.GENERIC,
    selectorType: RendererSelectorType.CLASS,
    selector: 'esr-contact-branch',
    component: () => {
      return <BranchContactPhone />;
    },
  },
];

function EquipmenClass() {
  useEffect(() => {
    renderer(componentsRegister);
  }, []);

  return null;
}

export default EquipmenClass;
